import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-verification-widget',
  templateUrl: './about-verification-widget.component.html',
  styleUrls: ['./about-verification-widget.component.scss'],
})
export class AboutVerificationWidgetComponent implements OnInit {
  @Input() modal: boolean;
  public infoArray = [...Array(7).keys()].map((i) => i + 1);
  constructor() {}

  ngOnInit() {}
}
